/*----------------------------------
- ROUTE: /resources/domaining-news/page/:page
----------------------------------*/

/**
 * @docs docs/features/domain-news
 */

/*----------------------------------
- DEPENDENCIES
----------------------------------*/

import { definePageRoute } from '@common/router/definitions';

import {
    buildDomainingNewsArchiveRouteData,
    renderDomainingNewsArchiveRoute,
} from './lib/route';

/*----------------------------------
- PAGE
----------------------------------*/

export default definePageRoute({
    path: '/resources/domaining-news/page/:page([1-9]\\d*)',
    options: { auth: false, layout: false, priority: 40 },
    data: buildDomainingNewsArchiveRouteData,
    render: renderDomainingNewsArchiveRoute,
});
